import { keyPathMirror } from 'key-path-mirror';

import { LocalesKey } from './localesKeysTypes';

export interface WordsType {
  accept: LocalesKey;
  accordingTo: LocalesKey;
  account: LocalesKey;
  accountManager: LocalesKey;
  active: LocalesKey;
  activity: LocalesKey;
  actions: LocalesKey;
  add: LocalesKey;
  addDescription: LocalesKey;
  addMessage: LocalesKey;
  addTag: LocalesKey;
  addItem: LocalesKey;
  addMore: LocalesKey;
  addReaction: LocalesKey;
  addService: LocalesKey;
  addToFavorites: LocalesKey;
  addUser: LocalesKey;
  addYourCommentOptional: LocalesKey;
  adorable: LocalesKey;
  all: LocalesKey;
  allActivity: LocalesKey;
  allAttachments: LocalesKey;
  attachments: LocalesKey;
  attachFile: LocalesKey;
  allocate: LocalesKey;
  allocateFunds: LocalesKey;
  allPages: LocalesKey;
  allStatuses: LocalesKey;
  allTime: LocalesKey;
  allUsers: LocalesKey;
  already_selected: LocalesKey;
  amount: LocalesKey;
  amountDue: LocalesKey;
  and: LocalesKey;
  andUpperCase: LocalesKey;
  conditions: LocalesKey;
  orUpperCase: LocalesKey;
  any: LocalesKey;
  anyType: LocalesKey;
  api: LocalesKey;
  applicationLanguage: LocalesKey;
  apply: LocalesKey;
  approve: LocalesKey;
  appliedEvents: LocalesKey;
  artists: LocalesKey;
  archivizerTeam: LocalesKey;
  as: LocalesKey;
  assignAsCreator: LocalesKey;
  assignAsOwner: LocalesKey;
  attach: LocalesKey;
  attachImage: LocalesKey;
  aud: LocalesKey;
  auto: LocalesKey;
  autoAllocate: LocalesKey;
  author: LocalesKey;
  aws: LocalesKey;
  back: LocalesKey;
  backToProject: LocalesKey;
  backtrace: LocalesKey;
  badDebt: LocalesKey;
  dataPrivacyPolicy: LocalesKey;
  block: LocalesKey;
  blocked: LocalesKey;
  brand: LocalesKey;
  brief: LocalesKey;
  browse: LocalesKey;
  budget: LocalesKey;
  by: LocalesKey;
  cad: LocalesKey;
  cancel: LocalesKey;
  canceled: LocalesKey;
  caution: LocalesKey;
  celebrate: LocalesKey;
  change: LocalesKey;
  changeCurrency: LocalesKey;
  changeOwner: LocalesKey;
  changeUnits: LocalesKey;
  clap: LocalesKey;
  clear: LocalesKey;
  clearAll: LocalesKey;
  clearFilter: LocalesKey;
  clearFilters: LocalesKey;
  clearSelection: LocalesKey;
  clickToCopy: LocalesKey;
  client: LocalesKey;
  clientDebt: LocalesKey;
  clientManager: LocalesKey;
  clients: LocalesKey;
  close: LocalesKey;
  colors: LocalesKey;
  colorScheme: LocalesKey;
  colorSchemeDark: LocalesKey;
  colorSchemeLight: LocalesKey;
  comment: LocalesKey;
  company: LocalesKey;
  companyCustomTabs: LocalesKey;
  companyTabs: LocalesKey;
  confirm: LocalesKey;
  contactInfo: LocalesKey;
  contactSupport: LocalesKey;
  continue: LocalesKey;
  control: LocalesKey;
  copy: LocalesKey;
  copyName: LocalesKey;
  copyGroupLink: LocalesKey;
  copyGroupName: LocalesKey;
  copyId: LocalesKey;
  copyLink: LocalesKey;
  copyProjectLink: LocalesKey;
  copyProjectName: LocalesKey;
  copyTaskLink: LocalesKey;
  copyTaskName: LocalesKey;
  copyUuid: LocalesKey;
  cost: LocalesKey;
  coefficient: LocalesKey;
  create: LocalesKey;
  createCustomTab: LocalesKey;
  createdBy: LocalesKey;
  createNewFilter: LocalesKey;
  createView: LocalesKey;
  criticalRequirements: LocalesKey;
  current: LocalesKey;
  custom: LocalesKey;
  customTabs: LocalesKey;
  date: LocalesKey;
  dateAndTimeFormat: LocalesKey;
  dateOfBirth: LocalesKey;
  day: LocalesKey;
  debt: LocalesKey;
  default: LocalesKey;
  delete_filter: LocalesKey;
  delete: LocalesKey;
  deleteView: LocalesKey;
  deleting: LocalesKey;
  deselect: LocalesKey;
  deselectLowerCase: LocalesKey;
  denyAccess: LocalesKey;
  description: LocalesKey;
  descriptionOptional: LocalesKey;
  digitalOcean: LocalesKey;
  disable: LocalesKey;
  dislike: LocalesKey;
  dontCloseOrRefresh: LocalesKey;
  download: LocalesKey;
  downloading: LocalesKey;
  downloadAll: LocalesKey;
  downloadAllUpperCase: LocalesKey;
  downloadTaskResult: LocalesKey;
  dpi: LocalesKey;
  draft: LocalesKey;
  draftBudget: LocalesKey;
  drawings: LocalesKey;
  dueDate: LocalesKey;
  duplicate: LocalesKey;
  edit: LocalesKey;
  editCustomTab: LocalesKey;
  editView: LocalesKey;
  elasticSearch: LocalesKey;
  emailAddress: LocalesKey;
  emailChanged: LocalesKey;
  enable: LocalesKey;
  endUserLicenseAgreementAndTermsOfService: LocalesKey;
  english: LocalesKey;
  enterMessageId: LocalesKey;
  enterMessageIds: LocalesKey;
  error: LocalesKey;
  errorMessage: LocalesKey;
  estimate: LocalesKey;
  eur: LocalesKey;
  existingField: LocalesKey;
  expand_view: LocalesKey;
  expenses: LocalesKey;
  export: LocalesKey;
  extract: LocalesKey;
  extracting: LocalesKey;
  favorite: LocalesKey;
  favorites: LocalesKey;
  field: LocalesKey;
  fileDownloadStarted: LocalesKey;
  files: LocalesKey;
  filter: LocalesKey;
  filterFavorite: LocalesKey;
  filters: LocalesKey;
  fin: LocalesKey;
  finance: LocalesKey;
  final: LocalesKey;
  fire: LocalesKey;
  featured: LocalesKey;
  flagged: LocalesKey;
  for: LocalesKey;
  forward: LocalesKey;
  from: LocalesKey;
  fullyPaid: LocalesKey;
  gbp: LocalesKey;
  gpt: LocalesKey;
  general: LocalesKey;
  generate: LocalesKey;
  globalCustom: LocalesKey;
  goBack: LocalesKey;
  groupBy: LocalesKey;
  gridView: LocalesKey;
  help: LocalesKey;
  helpCenter: LocalesKey;
  hidden: LocalesKey;
  hiddenLowerCase: LocalesKey;
  hide: LocalesKey;
  hideDimensions: LocalesKey;
  hideRuler: LocalesKey;
  hideList: LocalesKey;
  high: LocalesKey;
  home: LocalesKey;
  homepage: LocalesKey;
  images: LocalesKey;
  imageScale: LocalesKey;
  import: LocalesKey;
  in: LocalesKey;
  include: LocalesKey;
  included: LocalesKey;
  incomeStatement: LocalesKey;
  info: LocalesKey;
  invisibleForClient: LocalesKey;
  invisibleForWorker: LocalesKey;
  invisible: LocalesKey;
  invite_user: LocalesKey;
  inFavorites: LocalesKey;
  input: LocalesKey;
  itc: LocalesKey;
  its: LocalesKey;
  itemsList: LocalesKey;
  issues: LocalesKey;
  joined: LocalesKey;
  languagesSpoken: LocalesKey;
  lastMessage: LocalesKey;
  lastMonth: LocalesKey;
  lastWeek: LocalesKey;
  lastYear: LocalesKey;
  lastSixDays: LocalesKey;
  lastSixWeeks: LocalesKey;
  lastSixMonths: LocalesKey;
  lastSixQuarters: LocalesKey;
  lastSixYears: LocalesKey;
  latest: LocalesKey;
  laughing: LocalesKey;
  ld: LocalesKey;
  learnMore: LocalesKey;
  leave: LocalesKey;
  leaveMessage: LocalesKey;
  lessMonth: LocalesKey;
  lessTwoMonth: LocalesKey;
  lessTwoWeek: LocalesKey;
  lessWeek: LocalesKey;
  letters: {
    h: LocalesKey;
    m: LocalesKey;
  };
  license: LocalesKey;
  like: LocalesKey;
  link: LocalesKey;
  linkCopied: LocalesKey;
  listView: LocalesKey;
  loadMore: LocalesKey;
  loadingMore: LocalesKey;
  loa: LocalesKey;
  loaUntil: LocalesKey;
  location: LocalesKey;
  log_out: LocalesKey;
  login_page: LocalesKey;
  love: LocalesKey;
  low: LocalesKey;
  mad: LocalesKey;
  makeInvisible: LocalesKey;
  makeVisible: LocalesKey;
  makeDefault: LocalesKey;
  media: LocalesKey;
  members: LocalesKey;
  membersGenitiveLowerCase: LocalesKey;
  mergeSimilar: LocalesKey;
  mixed: LocalesKey;
  model: LocalesKey;
  modelWithExtensions: LocalesKey;
  month: LocalesKey;
  more: LocalesKey;
  moreTwoMonth: LocalesKey;
  mostLiked: LocalesKey;
  mostUsed: LocalesKey;
  move: LocalesKey;
  myLibrary: LocalesKey;
  myCompanyFavorites: LocalesKey;
  companyFavorite: LocalesKey;
  companyFavorites: LocalesKey;
  multiline: LocalesKey;
  muteNotifications: LocalesKey;
  mute: LocalesKey;
  na: LocalesKey;
  name: LocalesKey;
  nameEn: LocalesKey;
  nameCopied: LocalesKey;
  nda: LocalesKey;
  ndaFile: LocalesKey;
  needHelp: LocalesKey;
  next: LocalesKey;
  new: LocalesKey;
  newest: LocalesKey;
  newField: LocalesKey;
  newVersionAvailable: LocalesKey;
  net: LocalesKey;
  no: LocalesKey;
  noGrouping: LocalesKey;
  noResultsYet: LocalesKey;
  noSearchResults: LocalesKey;
  notAsked: LocalesKey;
  notification: LocalesKey;
  notificationsEnabled: LocalesKey;
  of: LocalesKey;
  ok: LocalesKey;
  on: LocalesKey;
  onboardingTour: LocalesKey;
  oneDay: LocalesKey;
  oneMonth: LocalesKey;
  oneWeek: LocalesKey;
  open_in_new_tab: LocalesKey;
  open: LocalesKey;
  openOptions: LocalesKey;
  or: LocalesKey;
  orLowerCase: LocalesKey;
  overdue: LocalesKey;
  output: LocalesKey;
  owner: LocalesKey;
  paid: LocalesKey;
  passwordChanged: LocalesKey;
  pay: LocalesKey;
  payByCard: LocalesKey;
  payOnline: LocalesKey;
  payer: LocalesKey;
  paymentMethod: LocalesKey;
  paste: LocalesKey;
  payments: LocalesKey;
  pastPayments: LocalesKey;
  pause: LocalesKey;
  paymentTerms: LocalesKey;
  paymentTermsAndRefundPolicy: LocalesKey;
  pendingPayments: LocalesKey;
  phoneNumber: LocalesKey;
  pinned: LocalesKey;
  policies: LocalesKey;
  play: LocalesKey;
  planned: LocalesKey;
  platformTerms: LocalesKey;
  pleaseDontCloseOrRefreshThePageUntilItsDoneDoingSoWillStopTheDownload: LocalesKey;
  postMessage: LocalesKey;
  premiumContent: LocalesKey;
  previewModel: LocalesKey;
  previewModelWithExtensions: LocalesKey;
  price: LocalesKey;
  privacy: LocalesKey;
  privacyPolicy: LocalesKey;
  proceed: LocalesKey;
  processing: LocalesKey;
  profile: LocalesKey;
  proforma: LocalesKey;
  proformaOld: LocalesKey;
  progress: LocalesKey;
  publish: LocalesKey;
  published: LocalesKey;
  px: LocalesKey;
  quantity: LocalesKey;
  receipt: LocalesKey;
  receiveNotifications: LocalesKey;
  receiver: LocalesKey;
  recentlySelected: LocalesKey;
  references: LocalesKey;
  refineSearch: LocalesKey;
  refund: LocalesKey;
  refunds: LocalesKey;
  refresh: LocalesKey;
  remove: LocalesKey;
  removeAll: LocalesKey;
  removeFromFavorites: LocalesKey;
  rename: LocalesKey;
  requirements: LocalesKey;
  reset_password: LocalesKey;
  required: LocalesKey;
  reset: LocalesKey;
  resetFilters: LocalesKey;
  resolve: LocalesKey;
  resolved: LocalesKey;
  results: LocalesKey;
  resultsFor: LocalesKey;
  restore: LocalesKey;
  rub: LocalesKey;
  russian: LocalesKey;
  sad: LocalesKey;
  save: LocalesKey;
  saveACopy: LocalesKey;
  saveChanges: LocalesKey;
  saved: LocalesKey;
  savedFilters: LocalesKey;
  saveFilter: LocalesKey;
  saveToFavorites: LocalesKey;
  scopeOfWork: LocalesKey;
  score: LocalesKey;
  search_user_by_name: LocalesKey;
  search: LocalesKey;
  searching: LocalesKey;
  searchResults: LocalesKey;
  searchByCompanyName: LocalesKey;
  searchByName: LocalesKey;
  secondsGenitive: LocalesKey;
  select: LocalesKey;
  selectAll: LocalesKey;
  selected: LocalesKey;
  selectedLowerCase: LocalesKey;
  selectToAddToTheProject: LocalesKey;
  send: LocalesKey;
  sendTo: LocalesKey;
  sentTo: LocalesKey;
  sender: LocalesKey;
  sendInstructions: LocalesKey;
  sendToAllTasks: LocalesKey;
  sendToEmail: LocalesKey;
  sendViaEmail: LocalesKey;
  sent: LocalesKey;
  serviceAgreement: LocalesKey;
  serviceName: LocalesKey;
  set: LocalesKey;
  setAllVisible: LocalesKey;
  setAllHidden: LocalesKey;
  setCustomDate: LocalesKey;
  setDueDate: LocalesKey;
  settings: LocalesKey;
  show_n_selected_items: {
    show: LocalesKey;
    hide: LocalesKey;
    selected_items: LocalesKey;
  };
  show: LocalesKey;
  showAll: LocalesKey;
  showDimensions: LocalesKey;
  showRuler: LocalesKey;
  showFavoriteOnly: LocalesKey;
  showFavoritesOfMyCompany: LocalesKey;
  showing: LocalesKey;
  showLess: LocalesKey;
  showList: LocalesKey;
  showMore: LocalesKey;
  showMyLibrary: LocalesKey;
  showTotals: LocalesKey;
  sign_out: LocalesKey;
  size: LocalesKey;
  sketches: LocalesKey;
  skip: LocalesKey;
  skipStep: LocalesKey;
  sku: LocalesKey;
  smartContract: LocalesKey;
  sortAZ: LocalesKey;
  sortZA: LocalesKey;
  sortBy: LocalesKey;
  sortByMostLiked: LocalesKey;
  sortByMostUsed: LocalesKey;
  sortByNewest: LocalesKey;
  sortByFeatured: LocalesKey;
  starred: LocalesKey;
  startDate: LocalesKey;
  state: LocalesKey;
  status: LocalesKey;
  statusColon: LocalesKey;
  renderer: LocalesKey;
  style: LocalesKey;
  tableView: LocalesKey;
  start: LocalesKey;
  stop: LocalesKey;
  stopAll: LocalesKey;
  studio: LocalesKey;
  submit: LocalesKey;
  subscribed: LocalesKey;
  subscribeAgain: LocalesKey;
  success: LocalesKey;
  surnameEn: LocalesKey;
  surprised: LocalesKey;
  system: LocalesKey;
  tagName: LocalesKey;
  task: LocalesKey;
  tax: LocalesKey;
  tbd: LocalesKey;
  terms: LocalesKey;
  termsOfService: LocalesKey;
  terrified: LocalesKey;
  testProjectInfo: LocalesKey;
  textHere: LocalesKey;
  textures: LocalesKey;
  tfe: LocalesKey;
  thereAreNoMatchesForSelectedFilters: LocalesKey;
  threeDs: LocalesKey;
  threeDStock: LocalesKey;
  thisMonth: LocalesKey;
  time: LocalesKey;
  timer: {
    days: LocalesKey;
    hours: LocalesKey;
    minutes: LocalesKey;
    seconds: LocalesKey;
  };
  times: LocalesKey;
  timeZone: LocalesKey;
  to: LocalesKey;
  today: LocalesKey;
  toFavorites: LocalesKey;
  total: LocalesKey;
  totalDebt: LocalesKey;
  toggleView: LocalesKey;
  trackedTime: LocalesKey;
  tryAgain: LocalesKey;
  uah: LocalesKey;
  ukraine: LocalesKey;
  unblock: LocalesKey;
  underpayment: LocalesKey;
  unselectAllItems: LocalesKey;
  undefined: LocalesKey;
  unmute: LocalesKey;
  unmuteAgain: LocalesKey;
  unit: LocalesKey;
  units: {
    cm: LocalesKey;
    in: LocalesKey;
  };
  untagged: LocalesKey;
  ungrouped: LocalesKey;
  until: LocalesKey;
  unfavorite: LocalesKey;
  unstarred: LocalesKey;
  unsubscribed: LocalesKey;
  unsubscribe: LocalesKey;
  update: LocalesKey;
  updated: LocalesKey;
  updateExistingFilter: LocalesKey;
  updateImageVersions: LocalesKey;
  updateNow: LocalesKey;
  upload: LocalesKey;
  uploaded: LocalesKey;
  usd: LocalesKey;
  used: LocalesKey;
  user: LocalesKey;
  useDefaultView: LocalesKey;
  vat: LocalesKey;
  view: LocalesKey;
  view3DModel: LocalesKey;
  viewAccounts: LocalesKey;
  viewAll: LocalesKey;
  viewAllMembers: LocalesKey;
  viewCR: LocalesKey;
  viewProfile: LocalesKey;
  visibility: LocalesKey;
  visibilityForClient: LocalesKey;
  visibilityForWorker: LocalesKey;
  visible: LocalesKey;
  visibleForClient: LocalesKey;
  void: LocalesKey;
  week: LocalesKey;
  welcomeToArchivizer: LocalesKey;
  whiteboard: LocalesKey;
  withdraw: LocalesKey;
  workers: LocalesKey;
  watchGuide: LocalesKey;
  workflowGuide: LocalesKey;
  writeHere: LocalesKey;
  whiteboardNotifications: LocalesKey;
  yes: LocalesKey;
  yesterday: LocalesKey;
  inherit: LocalesKey;
  star: LocalesKey;
  flag: LocalesKey;
  notify: LocalesKey;
}

export const words = keyPathMirror<WordsType, string>(
  {
    accept: null,
    accordingTo: null,
    account: null,
    accountManager: null,
    active: null,
    activity: null,
    actions: null,
    add: null,
    addDescription: null,
    addMessage: null,
    addTag: null,
    addItem: null,
    addMore: null,
    addReaction: null,
    addService: null,
    addToFavorites: null,
    addUser: null,
    addYourCommentOptional: null,
    adorable: null,
    all: null,
    allActivity: null,
    allAttachments: null,
    attachments: null,
    attachFile: null,
    allocate: null,
    allocateFunds: null,
    allPages: null,
    allStatuses: null,
    allTime: null,
    allUsers: null,
    already_selected: null,
    amount: null,
    amountDue: null,
    and: null,
    andUpperCase: null,
    conditions: null,
    orUpperCase: null,
    any: null,
    anyType: null,
    api: null,
    applicationLanguage: null,
    apply: null,
    approve: null,
    appliedEvents: null,
    artists: null,
    archivizerTeam: null,
    as: null,
    assignAsCreator: null,
    assignAsOwner: null,
    attach: null,
    attachImage: null,
    aud: null,
    auto: null,
    autoAllocate: null,
    author: null,
    aws: null,
    back: null,
    backToProject: null,
    backtrace: null,
    badDebt: null,
    dataPrivacyPolicy: null,
    block: null,
    blocked: null,
    brand: null,
    brief: null,
    browse: null,
    budget: null,
    by: null,
    cad: null,
    cancel: null,
    canceled: null,
    caution: null,
    celebrate: null,
    change: null,
    changeCurrency: null,
    changeOwner: null,
    changeUnits: null,
    clap: null,
    clear: null,
    clearAll: null,
    clearFilter: null,
    clearFilters: null,
    clearSelection: null,
    clickToCopy: null,
    client: null,
    clientDebt: null,
    clientManager: null,
    clients: null,
    close: null,
    colors: null,
    colorScheme: null,
    colorSchemeDark: null,
    colorSchemeLight: null,
    comment: null,
    company: null,
    companyCustomTabs: null,
    companyTabs: null,
    confirm: null,
    contactInfo: null,
    contactSupport: null,
    continue: null,
    control: null,
    copy: null,
    copyName: null,
    copyGroupLink: null,
    copyGroupName: null,
    copyId: null,
    copyLink: null,
    copyProjectLink: null,
    copyProjectName: null,
    copyTaskLink: null,
    copyTaskName: null,
    copyUuid: null,
    cost: null,
    coefficient: null,
    create: null,
    createCustomTab: null,
    createdBy: null,
    createNewFilter: null,
    createView: null,
    criticalRequirements: null,
    current: null,
    custom: null,
    customTabs: null,
    date: null,
    dateAndTimeFormat: null,
    dateOfBirth: null,
    day: null,
    debt: null,
    default: null,
    delete_filter: null,
    delete: null,
    deleteView: null,
    deleting: null,
    deselect: null,
    deselectLowerCase: null,
    denyAccess: null,
    description: null,
    descriptionOptional: null,
    digitalOcean: null,
    disable: null,
    dislike: null,
    dontCloseOrRefresh: null,
    download: null,
    downloading: null,
    downloadAll: null,
    downloadAllUpperCase: null,
    downloadTaskResult: null,
    dpi: null,
    draft: null,
    draftBudget: null,
    drawings: null,
    dueDate: null,
    duplicate: null,
    edit: null,
    editCustomTab: null,
    editView: null,
    elasticSearch: null,
    emailAddress: null,
    emailChanged: null,
    enable: null,
    endUserLicenseAgreementAndTermsOfService: null,
    english: null,
    enterMessageId: null,
    enterMessageIds: null,
    error: null,
    errorMessage: null,
    estimate: null,
    eur: null,
    existingField: null,
    expand_view: null,
    expenses: null,
    export: null,
    extract: null,
    extracting: null,
    favorite: null,
    favorites: null,
    field: null,
    fileDownloadStarted: null,
    files: null,
    filter: null,
    filterFavorite: null,
    filters: null,
    fin: null,
    finance: null,
    final: null,
    fire: null,
    featured: null,
    flagged: null,
    for: null,
    forward: null,
    from: null,
    fullyPaid: null,
    gbp: null,
    gpt: null,
    general: null,
    generate: null,
    globalCustom: null,
    goBack: null,
    groupBy: null,
    gridView: null,
    help: null,
    helpCenter: null,
    hidden: null,
    hiddenLowerCase: null,
    hide: null,
    hideDimensions: null,
    hideRuler: null,
    hideList: null,
    high: null,
    home: null,
    homepage: null,
    images: null,
    imageScale: null,
    import: null,
    in: null,
    include: null,
    included: null,
    incomeStatement: null,
    info: null,
    invisibleForClient: null,
    invisibleForWorker: null,
    invisible: null,
    invite_user: null,
    inFavorites: null,
    input: null,
    itc: null,
    its: null,
    itemsList: null,
    issues: null,
    joined: null,
    languagesSpoken: null,
    lastMessage: null,
    lastMonth: null,
    lastWeek: null,
    lastYear: null,
    lastSixDays: null,
    lastSixWeeks: null,
    lastSixMonths: null,
    lastSixQuarters: null,
    lastSixYears: null,
    latest: null,
    laughing: null,
    ld: null,
    learnMore: null,
    leave: null,
    leaveMessage: null,
    lessMonth: null,
    lessTwoMonth: null,
    lessTwoWeek: null,
    lessWeek: null,
    letters: {
      h: null,
      m: null
    },
    license: null,
    like: null,
    link: null,
    linkCopied: null,
    listView: null,
    loadMore: null,
    loadingMore: null,
    loa: null,
    loaUntil: null,
    location: null,
    log_out: null,
    login_page: null,
    love: null,
    low: null,
    mad: null,
    makeInvisible: null,
    makeVisible: null,
    makeDefault: null,
    media: null,
    members: null,
    membersGenitiveLowerCase: null,
    mergeSimilar: null,
    mixed: null,
    model: null,
    modelWithExtensions: null,
    month: null,
    more: null,
    moreTwoMonth: null,
    mostLiked: null,
    mostUsed: null,
    move: null,
    myLibrary: null,
    myCompanyFavorites: null,
    companyFavorite: null,
    companyFavorites: null,
    multiline: null,
    muteNotifications: null,
    mute: null,
    na: null,
    name: null,
    nameEn: null,
    nameCopied: null,
    nda: null,
    ndaFile: null,
    needHelp: null,
    next: null,
    new: null,
    newest: null,
    newField: null,
    newVersionAvailable: null,
    net: null,
    no: null,
    noGrouping: null,
    noResultsYet: null,
    noSearchResults: null,
    notAsked: null,
    notification: null,
    notificationsEnabled: null,
    of: null,
    ok: null,
    on: null,
    onboardingTour: null,
    oneDay: null,
    oneMonth: null,
    oneWeek: null,
    open_in_new_tab: null,
    open: null,
    openOptions: null,
    or: null,
    orLowerCase: null,
    overdue: null,
    output: null,
    owner: null,
    paid: null,
    passwordChanged: null,
    pay: null,
    payByCard: null,
    payOnline: null,
    payer: null,
    paste: null,
    paymentMethod: null,
    payments: null,
    pause: null,
    pastPayments: null,
    paymentTerms: null,
    paymentTermsAndRefundPolicy: null,
    pendingPayments: null,
    phoneNumber: null,
    pinned: null,
    play: null,
    planned: null,
    platformTerms: null,
    pleaseDontCloseOrRefreshThePageUntilItsDoneDoingSoWillStopTheDownload: null,
    policies: null,
    postMessage: null,
    premiumContent: null,
    previewModel: null,
    previewModelWithExtensions: null,
    price: null,
    privacy: null,
    privacyPolicy: null,
    proceed: null,
    processing: null,
    profile: null,
    proforma: null,
    proformaOld: null,
    progress: null,
    publish: null,
    published: null,
    px: null,
    quantity: null,
    receipt: null,
    receiveNotifications: null,
    receiver: null,
    recentlySelected: null,
    references: null,
    refineSearch: null,
    refund: null,
    refunds: null,
    refresh: null,
    remove: null,
    removeAll: null,
    removeFromFavorites: null,
    rename: null,
    requirements: null,
    reset_password: null,
    required: null,
    reset: null,
    resetFilters: null,
    resolve: null,
    resolved: null,
    restore: null,
    results: null,
    resultsFor: null,
    rub: null,
    russian: null,
    sad: null,
    save: null,
    saveACopy: null,
    saveChanges: null,
    saved: null,
    savedFilters: null,
    saveFilter: null,
    saveToFavorites: null,
    scopeOfWork: null,
    score: null,
    search_user_by_name: null,
    search: null,
    searching: null,
    searchResults: null,
    searchByCompanyName: null,
    searchByName: null,
    secondsGenitive: null,
    select: null,
    selectAll: null,
    selected: null,
    selectedLowerCase: null,
    selectToAddToTheProject: null,
    send: null,
    sendTo: null,
    sentTo: null,
    sender: null,
    sendInstructions: null,
    sendToAllTasks: null,
    sendToEmail: null,
    sendViaEmail: null,
    sent: null,
    serviceAgreement: null,
    serviceName: null,
    set: null,
    setAllVisible: null,
    setAllHidden: null,
    setCustomDate: null,
    setDueDate: null,
    settings: null,
    show_n_selected_items: {
      show: null,
      hide: null,
      selected_items: null
    },
    show: null,
    showAll: null,
    showDimensions: null,
    showRuler: null,
    showFavoriteOnly: null,
    showFavoritesOfMyCompany: null,
    showing: null,
    showLess: null,
    showList: null,
    showMore: null,
    showMyLibrary: null,
    showTotals: null,
    sign_out: null,
    size: null,
    sketches: null,
    skip: null,
    skipStep: null,
    sku: null,
    smartContract: null,
    sortAZ: null,
    sortZA: null,
    sortBy: null,
    sortByMostLiked: null,
    sortByMostUsed: null,
    sortByNewest: null,
    sortByFeatured: null,
    starred: null,
    startDate: null,
    state: null,
    status: null,
    statusColon: null,
    renderer: null,
    style: null,
    tableView: null,
    start: null,
    stop: null,
    stopAll: null,
    studio: null,
    submit: null,
    subscribed: null,
    subscribeAgain: null,
    success: null,
    surnameEn: null,
    surprised: null,
    system: null,
    tagName: null,
    task: null,
    tax: null,
    tbd: null,
    terms: null,
    termsOfService: null,
    terrified: null,
    testProjectInfo: null,
    textHere: null,
    textures: null,
    tfe: null,
    thereAreNoMatchesForSelectedFilters: null,
    threeDs: null,
    threeDStock: null,
    thisMonth: null,
    time: null,
    timer: {
      days: null,
      hours: null,
      minutes: null,
      seconds: null
    },
    times: null,
    timeZone: null,
    to: null,
    today: null,
    toFavorites: null,
    total: null,
    totalDebt: null,
    toggleView: null,
    trackedTime: null,
    tryAgain: null,
    uah: null,
    ukraine: null,
    unblock: null,
    underpayment: null,
    unselectAllItems: null,
    undefined: null,
    unmute: null,
    unmuteAgain: null,
    unit: null,
    units: {
      cm: null,
      in: null
    },
    untagged: null,
    ungrouped: null,
    until: null,
    unfavorite: null,
    unstarred: null,
    unsubscribed: null,
    unsubscribe: null,
    update: null,
    updated: null,
    updateExistingFilter: null,
    updateImageVersions: null,
    updateNow: null,
    upload: null,
    uploaded: null,
    usd: null,
    used: null,
    user: null,
    useDefaultView: null,
    vat: null,
    view: null,
    view3DModel: null,
    viewAccounts: null,
    viewAll: null,
    viewAllMembers: null,
    viewCR: null,
    viewProfile: null,
    visibility: null,
    visibilityForClient: null,
    visibilityForWorker: null,
    visible: null,
    visibleForClient: null,
    void: null,
    week: null,
    welcomeToArchivizer: null,
    whiteboard: null,
    withdraw: null,
    workers: null,
    watchGuide: null,
    workflowGuide: null,
    writeHere: null,
    whiteboardNotifications: null,
    yes: null,
    yesterday: null,
    inherit: null,
    star: null,
    flag: null,
    notify: null
  },
  'words.'
);
